// API Configuration for ShuttleClash
// Centralized configuration for all API endpoints and authentication

// Base API URL
export const API_BASE_URL = "https://shuttleclashapi.tieupsolutions.com/api";

// Access Token (JWT)
export const ACCESS_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxIiwiVXNlck5hbWUiOiI5Nzg5NTA3NjkxIiwiQXBwbGljYXRpb25Vc2VySUQiOiIxIiwiQ2xpZW50SUQiOiIxIiwiSXNBZG1pbiI6IlRydWUiLCJVc2VyVHlwZSI6IklVIiwianRpIjoiMTdmZjU2OGMtOWQwOS00OWU1LTkyZWUtZWFlMTY3NzIxYWY1IiwiZXhwIjoxNzU3NDk4NDY0LCJpc3MiOiJyYXBpZHNvZnQiLCJhdWQiOiJBSVVzZXIifQ.12XiuXS0GngUR_PpJ3MtbZBTYVzGG-JKg4dffuXoh3s";

// API Endpoints
export const API_ENDPOINTS = {
  // Shuttle Booking
  SHUTTLE_BOOKING: `${API_BASE_URL}/ShuttleBooking`,
  UPLOAD_ATTACHMENT: `${API_BASE_URL}/ShuttleBooking/UploadAttachment`,
  
  // Payment
  PAYMENT_ORDER_STATUS: `${API_BASE_URL}/Payment/order-status`,
  PHONEPE_PAY: `${API_BASE_URL}/Payment/phonepe-pay`,
};

// Common headers for API requests
export const getAuthHeaders = (contentType = "application/json") => {
  const headers = {
    "Authorization": `Bearer ${ACCESS_TOKEN}`,
  };
  
  if (contentType) {
    headers["Content-Type"] = contentType;
  }
  
  return headers;
};

// API request helper functions
export const apiRequest = async (url, options = {}) => {
  const defaultOptions = {
    headers: getAuthHeaders(),
    ...options,
  };
  
  const response = await fetch(url, defaultOptions);
  
  if (!response.ok) {
    throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
};

// Specific API functions
export const registerPlayer = async (data) => {
  return apiRequest(API_ENDPOINTS.SHUTTLE_BOOKING, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const uploadAttachment = async (shuttleBookingID, file) => {
  const formData = new FormData();
  formData.append("shuttleBookingID", shuttleBookingID);
  formData.append("files", file);
  
  return apiRequest(API_ENDPOINTS.UPLOAD_ATTACHMENT, {
    method: "POST",
    headers: getAuthHeaders(null), // No Content-Type for FormData
    body: formData,
  });
};

export const verifyPaymentStatus = async (shuttleBookingID) => {
  return apiRequest(`${API_ENDPOINTS.PAYMENT_ORDER_STATUS}?shuttleBookingID=${shuttleBookingID}`, {
    method: "POST",
    headers: {
      ...getAuthHeaders(),
      "accept": "*/*",
    },
  });
};

export const initiatePhonePePayment = async (shuttleBookingID) => {
  return apiRequest(`${API_ENDPOINTS.PHONEPE_PAY}?shuttleBookingID=${shuttleBookingID}`, {
    method: "POST",
    headers: {
      ...getAuthHeaders(),
      "accept": "*/*",
    },
    body: "",
  });
};
